const translations = {
  en: {
    schedule: 'Book',

    enterPhoneForOtp: 'Enter phone number',

    phoneNumber: 'Phone',

    send: 'Send',

    enterPinForOtp: 'Enter the verification code that you received via message to ',

    chooseStaff: 'Choose staff',

    chooseService: 'Choose service',

    morning: 'Morning',

    afternoon: 'Afternoon',

    night: 'Evening', // Edited by

    confirm: 'Book appointment',

    name: 'Full name',

    enterFullName: 'Enter full name',

    login: 'Login',

    sunday: 'Sunday',

    monday: 'Monday',

    tuesday: 'Tuesday',

    wednesday: 'Wednesday',

    thursday: 'Thursday',

    friday: 'Friday',

    saturday: 'Saturday',

    openingHours: 'Hours',

    closed: 'Closed',

    social: 'Social',

    book: 'Book',

    signIn: 'Sign In',

    signOut: 'Sign Out',

    appoitment: 'Appointment',

    appoitments: 'Appointments',

    cancel: 'Cancel',

    canceled: 'Canceled',

    at: 'at',

    reschedule: 'Reschedule',

    invalidPhone: `Invalid Phone Number. Please enter a valid format.
  
  For example: +9722345678901 or 05012345678`,

    generalError: 'An error has occurred. Please try again later.',

    appointmentError:
      'We encountered an issue while scheduling. This appointment may have been taken or passed, please try again.',

    wrongPinError:
      "PIN code entered is incorrect. Please ensure you're using the correct code sent to your phone number and try again.",

    // Start Working Hours

    workingHours: 'Working Hours',

    selectStaff: 'Select Staff member', // Edited by

    timeZone: 'Time Zone',

    weeklyWorkingHours: 'Weekly Working Hours',

    start: 'Start',

    end: 'End',

    addShift: 'Add Shift',

    update: 'Update',

    dateSpecificHours: 'Date-Specific Hours',

    dateSpecificText:
      'Override your availability for specific dates when your hours differ from your regular weekly hours.',

    addDateSpecificHours: 'Add Date-Specific Hours',

    // Working Hours Spinner

    updating: 'Updating',

    updatingText: 'This may take a few seconds',

    stats: 'Stats',

    jerusalem: 'Jerusalem',

    open: 'Open',

    weeklyHours: 'Weekly Hours',

    datesOverrides: 'Specific Dates',

    // Menu items

    customers: 'Customers',

    chats: 'Chats',

    appointment: 'Appointment',

    appointments: 'Appointments',

    chooseCustomer: 'Choose customer',

    scheduleFor: 'Schedule For',

    staff: 'Staff member', // Edited by

    service: 'Service',
    services: 'Services',

    loginText:
      "Please enter the mobile number associated with your business account. We'll use this number to send a verification code for login confirmation.",

    typePhone: 'Type your phone number',

    twoSteps: 'Two Step Verification',

    sentOtp:
      'We sent a verification code to your mobile. Enter the code from the mobile in the field below.',

    enter6digits: 'Type your 6 digits security code',

    resend: 'Resend',

    didntRecieve: "Didn't get the code?",

    sundayFormatted: 'Sun',

    mondayFormatted: 'Mon',

    tuesdayFormatted: 'Tue',

    wednesdayFormatted: 'Wed',

    thursdayFormatted: 'Thu',

    fridayFormatted: 'Fri',

    saturdayFormatted: 'Sat',

    // Recurring Appointments
    recurringAppointment: 'Recurring Appointment',
    recurringAppointments: 'Recurring Appointments',
    duplicateAppointments: 'Duplicate Appointments',
    noDuplicateAppointments: 'No duplicate appointments found',
    upcoming: 'Upcoming',
    recurringSettings: 'Recurring Settings',
    scheduleRecurring: 'Schedule Recurring',
    updateRecurring: 'Update',
    editRecurringRule: 'Edit Recurrence Rule',
    cancelSeries: 'Cancel Series',
    cancelRecurringSeries: 'Cancel Recurring Series',
    confirmCancelRecurringSeries: 'Are you sure you want to cancel this entire recurring series? All future appointments will be cancelled.',
    totalAppointments: 'Total Appointments',
    recurringEvent: 'Recurring',
    frequency: 'Frequency',
    dayOfWeek: 'Day of Week',
    every: 'Every',
    week: 'Week',
    weeks: 'Weeks',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    startDate: 'Start Date',
    details: 'Details',

    addCustomer: 'Add Customer',

    jane: 'Jane Smith',

    confirmAction: 'Confirm Action',

    scheduleWithoutCustomer: "You can't create an appointment without choosing a customer",

    yes: 'Yes', //Edited by

    no: 'No',

    nope: 'Cancel',

    addNewCustomer: 'Add new customer',

    reSchedule: 'Reschedule appointment',

    molla: 'Molla',

    nameShort: 'Name',

    previousAppointment: 'Previous Appointment',

    nextAppointment: 'Next Appointment',

    searchEverything: 'Search', // Edited by R

    today: 'Today',

    tomorrow: 'Tomorrow',

    //questionnaires

    questionnaires: 'Questionnaires',

    with: 'with',

    call: 'Call',

    whatsapp: 'WhatsApp', // Edited by

    block: 'Block',

    unblock: 'Unblock',

    lastConversation: 'Last Conversation',

    joined: 'Joined',

    status: 'Status',

    bookings: 'Bookings',

    payments: 'Payments',

    blocked: 'Blocked',

    active: 'Active',

    pending: 'Pending',

    blockConfirmAction: 'Are you sure you want to block',

    questionMark: '?',

    charge: 'Charge',

    time: 'Time',

    description: 'Description',

    price: '₪',

    cancelAppointmentDescription: 'Are you sure you want to cancel this appointment?',

    cancelAppointmentTitle: 'Cancel Appointment',

    noEventsMessage: 'No events yet',

    tag: 'Tags',

    addTag: 'Add Tag',

    addNewTag: 'Add New Tag',

    availableTags: 'Available Tags',

    modifyTag: 'Edit Tag',

    tagName: 'Tag Name',

    tagColor: 'Tag Color',

    invalidPhoneNumberTitle: 'Invalid phone number',

    invalidPhoneNumberMessage:
      'Please enter a valid phone number, ensuring it includes only numeric characters',

    ok: 'Okay',

    sessionExpiredTitle: 'Session expired',

    sessionExpiredDescription: 'Your session has expired. Please log in again to continue.',

    add: 'Add',

    noResults: 'No entries available',

    // login page general error

    loginErrorMsgTitle: 'Oops! There was an issue with your login',

    loginErrorMsgDescription: 'There is an error with your login, please try again',

    // already scheduled customer

    alreadyScheduledCustomerTitle: 'Reschedule Appointment',

    alreadyScheduledCustomerMessageP1: 'Heads up! The customer is already booked on',

    alreadyScheduledCustomerMessageP2:
      'If you need to adjust their appointment, simply proceed to reschedule',

    new: 'New',

    notifications: 'Notifications',

    notification: 'Notification',

    archive: 'Archive',

    theArchive: 'Inbox',

    selectAll: 'Select All',

    deSelectAll: 'Deselect All',

    clearAllFilters: 'Clear all filters',

    whitelistRequest: 'Wants to be your customer',

    approve: 'Approve',

    chargeErrorTitle: 'Incomplete Invoice Details',

    chargeErrorMessage:
      'One or more products listed have no price specified. Please ensure all products have prices before proceeding with the charge.',

    invoice: 'Invoice',

    billingTo: 'BILLING TO:',

    custom: 'Custom',

    products: 'Products',

    soon: 'Soon',

    total: 'TOTAL:',

    noChargableApts: "There aren't any chargeable appointments",

    copy: 'Copy',

    qrMessage: 'Scan, Copy or Send via WhatsApp', // Edited by

    whatsapp: 'Whatsapp',

    refundUserDeposit: "Refund user's deposit",

    selectBiz: 'Select Business',

    privacyPolicy: 'Privacy Policy',

    termsOfService: 'Terms of Service',

    needsAssistance: 'Needs Assistance',

    active: 'Active',

    slightlyActive: 'Slightly Active',

    notActive: 'Not Active',

    helpRequest: 'Wants your help',
    slighlyActiveRequestRami: 'Didnt respond to checkup yet',
    everythingIsFine: 'Everything is fine',

    helped: 'Helped',

    notes: 'Notes',

    addNote: 'Add your note',

    add: 'Add',

    profile: 'Profile',

    personalInfo: 'Personal Info',

    save: 'Save',

    edit: 'Edit',

    editQuestionnaire: 'Edit Questionnaire',

    invoiceSent: 'The invoice has been sent to the customer',

    priceWord: 'Price',

    view: 'View',

    refunded: 'Refunded',

    refund: 'Refund',

    paid: 'Paid',

    pending: 'Pending',

    outOf: ' out of ',

    refundCustomerTitle: 'Refund customer',

    refundCustomerText: 'Are you sure you want to return',

    to: 'to',

    scheduleAnotherAptTitle: 'Scheduling another appointment',

    scheduleAnotherAptText:
      'This customer already has a booking. Would you like to proceed with booking another one anyway?', // Edited by

    product: 'Product',

    download: 'Export',

    priceName: 'Price',

    quantity: 'Inventory',

    image: 'Image',

    editProduct: 'Edit Product',

    addProduct: 'Add Product',

    inStock: 'in stock',

    customer: 'Customer',

    missingInfoTitle: 'Missing or incorrect information',

    missingProductDetails: 'There are missing info in these languages:',

    showInBot: 'Show in bot',

    bundle: 'Bundle',

    orders: 'Orders',

    canceledAt: 'Canceled at',
    completedAt: 'Completed at',

    order: 'Order',
    datePlaced: 'Date placed',

    completed: 'Completed',
    canceled: 'Canceled',
    pending: 'Pending',

    complete: 'Complete',

    sortBy: 'Sort by',

    viewPendingOrder: 'Has a pending order, click to view',

    cancelOrder: 'Are you sure you want to cancel this order?',

    qty: 'Qty',

    soldOut: 'Sold out',

    contactUsSupport: 'Contact us at Support@wats-va.com',

    outOf: 'out of',

    deleteTagWarning: 'Are you sure you want to delete this tag?',
    deleteAddOnWarning: 'Are you sure you want to delete this add-on?',
    deleteTagCategory: 'Are you sure you want to delete this category?',

    select: 'Select',

    newUsers: 'New users',
    questionnairesAns: 'Questionnaires answers',

    overview: 'Overview',

    bookingsTotalNumber: 'Total number of bookings is',
    usersTotalNumber: 'Total number of users is',
    questionnairesTotalNumber: 'Total number of questionnaires answers is',

    thisMonth: 'This month',

    reviews: 'Reviews',
    totalReviews: 'Total reviews',
    avgRating: 'Average rating',
    ratingDistribution: 'Rating distribution',
    rating: 'Rating',
    reviewFeedback: 'Feedback',
    unknownCustomer: 'Unknown customer',
    pageOf: 'Page {page} of {total}',

    ooo: 'Out of Office',
    editooo: 'Edit Out of Office',
    title: 'Title',

    loginErrorBlockMsgDescription:
      'There have been 3 or more failed login attempts. Please try again in 1 minute',

    teamMangament: 'Team Management',

    team: 'Team',

    editService: 'Edit Service',
    addService: 'Add Service',
    serviceName: 'Service Name',
    category: 'Category',
    internalName: 'Internal Name',

    downPayment: 'Down Payment',

    cost: 'Price',

    duration: 'Duration',

    minutes: 'minutes',

    cancelFullRefundDaysBefore: 'Full refund if canceled before',

    days: 'Days',
    general: 'General',

    hasFutureApt: 'Future appointment',
    doesntHaveFutureApt: 'No future appointment',

    atLeastOneStaff:
      'There must be at least one staff member assigned to perform this type of service. If you wish to hide it, you may remove the appointment.',

    atLeastOneCharacter: 'Entry required. Please add at least one character',

    numericOnly: 'This field can only contain a number',

    charLimitMsg24: 'Character limit exceeded. WhatsApp allows a maximum of 24 characters',
    charLimitMsg60: 'Character limit exceeded. WhatsApp allows a maximum of 60 characters',

    missingOrRequired: 'Please complete all required fields, which are highlighted in red',

    addOns: 'Appointment Add-ons',

    addAppointment: 'Service',

    addAddOn: 'Add on',

    appointmentColor: 'Appointment Color',

    addCategory: 'Add category',
    editCategory: 'Edit category',

    categoryName: 'Category name',

    addingAddOn: 'Add Add-on',
    editAddOn: 'Edit Add-on',

    deleteAptWarning:
      'This action will permanently delete the appointment. Are you sure you want to proceed?',
    editStaffMember: 'Edit staff member',

    staffName: 'Staff memeber name',

    settings: 'Settings',

    saveAptB4TeamAssign: 'You must save the appointment before assigning team members',

    deleteStaffWarning:
      'This action will delete the staff. You can always undo this action. Are you sure you want to proceed?',

    clickHere: 'Click here',

    addOnDetials:
      'Add-ons help your clients add a common additional service to their appointment, such as asking for a blow-dry with their haircut.',
    addOnDetialsP2: 'It seems like you do not have any add-ons.',

    addOnFirstOne: 'to add your first add-on.',

    settingsIntro: 'Configure Offered Services',

    settingsP1: 'Here you can view and manage your offered services for you and your team.',
    settingsP2: 'All changes will appear in the chat-bot.',

    categoryEmpty: 'This category is empty. How about adding some services?',

    date: 'Date',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    timeTransfer: 'Transfer time',
    timePayment: 'Payment time',

    latestCheckUp: 'Latest checkup sent',
    latestCheckUpResponse: 'Latest checkup message response',

    customerAlreadyExists: 'Customer Already exists',

    error: 'Error',

    // downloadData: 'Download'

    serviceTime: 'Service time',

    mustHaveNameError: 'Please enter a customer name',
    moreDetails: 'More details',

    imIntrestedIn: `I am intrested in`,

    cancellationReason: 'Cancellation reason',

    other: 'Other',
    didntAttend: 'Didnt Attend',

    editAptDuration: 'Edit Appointment Duration',

    addToCart: 'Add to cart',
    shoppingCart: 'Shopping Cart',

    orderTotal: 'Order Total',
    subTotal: 'Sub Total',

    shippingPrice: 'Shipping',

    emptyCart: 'Cart is empty, start shopping',

    here: 'Here',

    shippingAdress: 'Shipping address',

    recipientName: 'Recipient Name',
    city: 'City',
    address1: 'Address',
    address2: 'Apartment, suite, etc.',
    postalCode: 'Postal Code',

    continuteToPayment: 'Continue to Payment',

    deliveryMethod: 'Delivery Method',

    shipping: 'Shipping',

    pickUp: 'Pick up',

    during: '',

    businessDays: 'business days',
    sigInWhatsapp: 'Sign in with WhatsApp',
    enterPhoneToCnt: 'Enter your phone number to continue',

    idNumber: 'Id Number',

    recipienAddress: 'Recipient Details',

    region: 'Region',

    north: 'North',
    center: 'Center',
    south: 'South',

    hiMoreDtls: 'Hi, I need more details about #',

    width: 'Width',
    height: 'Height',

    delete: 'Delete',
    color: 'Color',

    participants: 'Participants',

    groupEvent: 'Group Event',

    addNote: 'Add Note',
    enterNoteHere: 'Enter your note here...',

    resend: 'Resend',

    didntRecieve: "Didn't get the code?",

    resendIn: 'Resend in',

    sms: 'SMS',

    whatsappAuth: 'WhatsApp',

    failedToVerifyWhatsApp: 'Failed to verify WhatsApp code. Please try again.',

    selectAuthMethod: 'Select authentication method',
  },

  ar: {
    schedule: 'احجز',

    enterPhoneForOtp: 'اكتب رقم الهاتف للدخول',

    phoneNumber: 'رقم الهاتف',

    send: 'ارسل',

    enterPinForOtp: ' أدخل رمز التحقق الذي وصلك عبر رسالة الى ',

    chooseStaff: 'اختيار حلاق',

    chooseService: 'اختار الخدمة المناسبة', // Edited by

    morning: 'الصبح',

    afternoon: 'بعد الظهر',

    night: 'المساء',

    confirm: 'احجز',

    name: 'الاسم الكامل',

    enterFullName: 'اكتب اسمك الكامل',

    login: 'دخول',

    sunday: 'الأحد',

    monday: 'الاثنين',

    tuesday: 'الثلاثاء',

    wednesday: 'الأربعاء',

    thursday: 'الخميس',

    friday: 'الجمعة',

    saturday: 'السبت',

    openingHours: 'ساعات العمل',

    closed: 'مغلق',

    social: 'سوشيال',

    book: 'احجز',

    signIn: 'دخول',

    signOut: 'خروج',

    appoitment: 'دور',

    appoitments: 'جدول المواعيد',

    cancel: 'الغي',

    canceled: 'ملغي',

    reschedule: 'تغيير موعد',

    invalidPhone: `رقم هاتف غير صالح. الرجاء إدخال تنسيق صحيح.
  
  مثال: +9722345678901 أو 05012345678`,

    generalError: 'حدث خطأ. الرجاء المحاولة مرة أخرى لاحقًا.',

    appointmentError:
      '.واجهنا مشكلة أثناء الحجز. قد يكون هذا الموعد قد اُستُخدِم أو مضى، الرجاء المحاولة مرة أخرى',

    wrongPinError: 'الرمز السري خاطئ. تحقق من رمز التحقق وحاول مرة اخرى', // Edited by

    // Start Working Hours

    workingHours: 'ساعات العمل',

    selectStaff: 'اختيار موظّف',

    staff: 'موظّف',

    timeZone: 'منطقة زمنية',

    weeklyWorkingHours: 'ساعات العمل الأسبوعيّة',

    start: 'بداية',

    end: 'نهاية',

    addShift: 'إضافة ورديّة',

    update: 'تعديل',

    dateSpecificHours: 'ايام خاصة/ايام عطل',

    dateSpecificText: `.تعديل ساعات العمل الخاصة بك لتواريخ محددة عندما تختلف عن الساعات الأسبوعية المعتادة`,

    addDateSpecificHours: 'خاص/إضافة يوم عُطلة',

    // Working Hours Spinner

    updating: 'تعديل',

    updatingText: 'قد يستلزم الأمر بضع ثوان.',

    stats: 'إحصائيّات',

    jerusalem: 'القدس',

    open: 'مفتوح',

    weeklyHours: 'ساعات العمل الأسبوعيّة',

    datesOverrides: 'استثناءات',

    customers: 'زبائن',

    chats: 'محادثات',

    appointment: 'دور',

    appointments: 'مواعيد',

    chooseCustomer: 'اختيار زبون',

    scheduleFor: 'احجز دور في',

    service: 'خدمة',
    services: 'خدمات',

    loginText:
      'الرجاء إدخال رقم الهاتف المحمول المرتبط بحساب عملك. سنستخدم هذا الرقم لإرسال رمز التحقق لتأكيد تسجيل الدخول.',

    typePhone: 'اكتب رقم هاتفك',

    twoSteps: 'التحقّق بخطوتين',

    sentOtp: 'أرسلنا رمز التحقق إلى هاتفك المحمول. أدخل الرمز من الهاتف المحمول في الحقل أدناه.',

    enter6digits: 'اكتب رمز الأمان المكون من 6 أرقام',

    resend: 'إعادة إرسال',

    didntRecieve: 'لم تتلق الرمز؟',

    sundayFormatted: 'الأحد',

    mondayFormatted: 'الإثنين',

    tuesdayFormatted: 'الثلاثاء',

    wednesdayFormatted: 'الأربعاء',

    thursdayFormatted: 'الخميس',

    fridayFormatted: 'الجمعة',

    saturdayFormatted: 'السبت',

    // Recurring Appointments
    recurringAppointment: 'موعد متكرر',
    recurringAppointments: 'مواعيد متكررة',
    duplicateAppointments: 'مواعيد مكررة',
    noDuplicateAppointments: 'لا توجد مواعيد مكررة',
    upcoming: 'قادم',
    recurringSettings: 'إعدادات التكرار',
    scheduleRecurring: 'حجز متكرر',
    updateRecurring: 'تحديث',
    editRecurringRule: 'تعديل قاعدة التكرار',
    cancelSeries: 'إلغاء السلسلة',
    cancelRecurringSeries: 'إلغاء السلسلة المتكررة',
    confirmCancelRecurringSeries: 'هل أنت متأكد أنك تريد إلغاء هذه السلسلة المتكررة بأكملها؟ سيتم إلغاء جميع المواعيد المستقبلية.',
    totalAppointments: 'إجمالي المواعيد',
    recurringEvent: 'متكرر',
    frequency: 'التكرار',
    dayOfWeek: 'يوم الأسبوع',
    every: 'كل',
    week: 'أسبوع',
    weeks: 'أسابيع',
    weekly: 'أسبوعي',
    biweekly: 'كل أسبوعين',
    monthly: 'شهري',
    startDate: 'تاريخ البدء',
    details: 'التفاصيل',

    addCustomer: 'اضافة زبون',

    jane: 'رامي سعد',

    confirmAction: 'تأكيد الإجراء',

    scheduleWithoutCustomer: 'هل أنت متأكد أنك تريد تحديد موعد دون اختيار موظّف؟', 

    yes: 'نعم',

    no: 'لا',

    nope: 'إلغاء',

    addNewCustomer: 'اضافة زبون جديد', 

    reSchedule: 'تأجيل الموعد',

    molla: 'Molla',

    nameShort: 'الاسم',

    previousAppointment: 'اخر زيارة',

    nextAppointment: 'الموعد القادم',

    searchEverything: 'ابحث',

    at: 'عالساعة',

    today: 'اليوم',

    tomorrow: 'بكرا',

    questionnaires: 'استبيانات',

    editQuestionnaire: 'تعديل استبيان',

    with: 'مع',

    call: 'اتصل',

    whatsapp: 'واتساب',

    block: 'بلوك', 

    unblock: 'فك البلوك', 

    lastConversation: 'اخر محادثة',

    joined: 'انضم',

    status: 'الحالة',

    bookings: 'حجوزات',

    payments: 'دفعات',

    blocked: 'محطوط بلوك', 

    active: 'فعّال',

    pending: 'قيد الانتظار',

    blockConfirmAction: ' متأكد بدك تحط بلوك؟', 

    questionMark: '؟',

    charge: 'تدفيع',

    time: 'الوقت',

    description: 'وصف',

    price: '₪',

    priceName: 'السعر',

    cancelAppointmentDescription: 'هل أنت متأكد من أنك تريد إلغاء هذا الموعد؟',

    cancelAppointmentTitle: 'إلغاء الموعد',

    noEventsMessage: 'لا يوجد حجوزات حاليا',

    tag: 'Tag', //Edited by

    addTag: 'اضافة tag', //Edited by

    addNewTag: 'اضافة tag جديد',

    availableTags: 'Tags المتاحة',

    tagName: 'اسم ال tag', //Edited by

    tagColor: 'لون التاچ', //Edited by

    invalidPhoneNumberTitle: 'رقم هاتف غير صالح',

    invalidPhoneNumberMessage: 'يرجى التأكد من إدخال رقم هاتف صحيح يتكون من أرقام فقط',

    ok: 'تمام',

    sessionExpiredTitle: 'انتهت الجلسة',

    sessionExpiredDescription: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',

    add: 'اضافة',

    noResults: 'لا توجد بيانات متاحة',

    // login page general error

    loginErrorMsgTitle: 'عذرًا! هناك مشكلة في تسجيل دخولك',

    loginErrorMsgDescription: 'هنالك مشكلة في تسجيل دخولك، يرجى المحاولة مجددًا',

    alreadyScheduledCustomerTitle: 'إعادة الجدولة',

    alreadyScheduledCustomerMessageP1: 'ملاحظة! للزبون دور بالفعل يوم', // Edited by

    alreadyScheduledCustomerMessageP2:
      'إذا كنت بحاجة لتعديل الموعد، يرجى الانتقال إلى إعادة الجدولة',

    new: 'جديد',

    notifications: 'إشعارات',

    notification: 'إشعار',

    archive: 'أرشيف',

    theArchive: 'الأرشيف',

    selectAll: 'اختر الكل',

    deSelectAll: 'الغاء تحديد الكل',

    clearAllFilters: 'مسح جميع الفلاتر',

    whitelistRequest: 'بده يصير زبون عندك', // Edited by

    approve: 'موافقة',

    chargeErrorTitle: 'تفاصيل الفاتورة غير كاملة',

    chargeErrorMessage:
      'تم تحديد منتج أو أكثر بدون سعر. يرجى التأكد من تحديد الأسعار لجميع المنتجات قبل المتابعة في عملية الدفع',

    invoice: 'فاتورة',

    billingTo: 'إرسال فاتورة إلى',

    custom: 'مشخّص',

    products: 'منتجات',

    soon: 'قريباً',

    total: 'المجموع',

    noChargeableApts: 'لا توجد مواعيد برسوم',

    copy: 'انسخ',

    qrMessage: 'انسخ أو أرسل عبر الواتساب',

    whatsapp: 'واتساب',

    refundUserDeposit: 'ترجيع عربون المستخدم',

    selectBiz: 'اختيار مشروع',

    privacyPolicy: 'سياسة الخصوصية',

    termsOfService: 'شروط الخدمة',

    outOf: ' من ',

    needsAssistance: 'بحاجة لاعتناء',

    active: 'فعّال',

    slightlyActive: 'فعّال جزئياً',

    notActive: 'غير فعّال',

    helpRequest: 'بدو مساعدة منك',

    helped: 'ساعدته', // Edited by

    notes: 'ملاحظات',

    addNote: 'اضف ملاحظة',

    add: 'اضافة',

    profile: 'حساب تعريفي',

    personalInfo: 'معلومات شخصية',

    save: 'احفظ',

    edit: 'تعديل',

    invoiceSent: 'تم إرسال الفاتورة إلى الزبون', // Edited by

    scheduleAnotherAptTitle: 'جدولة موعد آخر',

    scheduleAnotherAptText: 'لهذاالزبون موعد محجوز. بدك تحجز موعد اخر؟', // Edited by

    priceWord: 'السعر',

    view: 'مشاهدة',

    refunded: 'ارجاع', // Edited by

    refund: 'ترجيع',

    paid: 'مدفوع',

    pending: 'قيد الانتظار',

    refundCustomerTitle: 'ترجيع للزبون', // Edited by

    refundCustomerText: 'هل أنت متأكد من أنك تريد إعادة',

    to: 'الى',

    product: 'منتج',

    download: 'تحميل',

    quantity: 'الكمية', // Edited by

    image: 'صورة',

    editProduct: 'تعديل منتج',

    addProduct: 'اضافة منتج',

    inStock: 'في المخزن',

    customer: 'زبون',

    missingProductDetails: 'هناك معلومات مفقودة في هذه اللغات:',
    missingInfoTitle: 'معلومات ناقصة او مغلوطة',

    showInBot: 'فرجيه بالبوط',

    bundle: 'باقة',

    // Orders start
    orders: 'طلبات',
    canceledAt: 'ألغي في',
    completedAt: 'اكتمل في',

    order: 'طلب',
    datePlaced: 'تاريخ الطلب',

    completed: 'مكتمل',
    canceled: 'ملغى',
    pending: 'قيد الانتظار',

    complete: 'اكمل',

    sortBy: 'رتب حسب',

    viewPendingOrder: 'لديه طلب في انتظار، انقر للعرض',

    cancelOrder: 'هل أنت متأكد أنك تريد إلغاء هذا الطلب؟',

    qty: 'كمية',

    soldOut: 'نفذت الكمية',

    contactUsSupport: 'تواصل معنا على  Support@wats-va.com',

    outOf: 'من',

    modifyTag: 'تعديل Tag',

    ooo: 'خارج المكتب',
    editooo: 'تعديل خارج المكتب',

    title: 'العنوان',

    deleteTagWarning: 'هل أنت متأكد من أنك تريد حذف هذه الTag؟',
    deleteTagCategory: 'هل أنت متأكد من أنك تريد حذف هذه الفئة',
    deleteAddOnWarning: 'هل أنت متأكد من أنك تريد حذف هذه الاضافة',

    select: 'اختيار',

    newUsers: 'مستخدمون جدد',
    questionnairesAns: 'أجوبة الاستبيانات',

    overview: 'ملخص',

    usersTotalNumber: 'عدد المستخدمين الكلّي هو',
    bookingsTotalNumber: 'عدد الحجوزات الكلّي هو',
    questionnairesTotalNumber: 'عدد اجوبة الاستبيانات الكلّي هو',
    thisMonth: 'هذا الشهر',

    reviews: 'التقييمات',
    totalReviews: 'عدد التقييمات',
    avgRating: 'معدل التقييم',
    ratingDistribution: 'توزيع التقييمات',
    rating: 'التقييم',
    reviewFeedback: 'ملاحظات',
    unknownCustomer: 'زبون غير معروف',
    pageOf: 'صفحة {page} من {total}',

    loginErrorBlockMsgDescription:
      'لقد حاولت تسجيل الدخول ثلاث مرات أو أكثر بدون نجاح. يرجى المحاولة مجددًا بعد دقيقة واحدة',
    teamMangament: 'ادارة الفريق',

    team: 'فريق',

    editService: 'تعديل الخدمة',
    addService: 'اضافة خدمة',
    serviceName: 'اسم الخدمة',
    category: 'فئة',
    internalName: 'الاسم الداخلي',

    downPayment: 'عربون',

    cost: 'السعر',

    duration: 'مدة',
    slighlyActiveRequestRami: 'بعدو مش رادد على المحقق كونان',
    everythingIsFine: 'كلو تمام',

    minutes: 'دقيقة',

    cancelFullRefundDaysBefore: 'استرداد كامل إذا تم الإلغاء قبل',
    days: 'ايام',

    general: 'الكل',

    hasFutureApt: 'موعد قادم',
    doesntHaveFutureApt: 'فش موعد قادم',

    atLeastOneStaff:
      'يجب تعيين على الأقل موظف واحد لأداء هذا النوع من الخدمات. إذا كنت ترغب في إخفائه، يمكنك إزالة الخدمة.',

    charLimitMsg24: 'تم تجاوز الحد الأقصى لعدد الأحرف. واتساب يسمح بحد أقصى 24 حرفًا',
    charLimitMsg60: 'تم تجاوز الحد الأقصى لعدد الأحرف. واتساب يسمح بحد أقصى 60 حرفًا',
    missingOrRequired: 'يرجى إكمال جميع الحقول المطلوبة، والتي تم تمييزها باللون الأحمر',

    addOns: 'اضافة للدور',

    addAppointment: 'خدمة جديدة',

    addAddOn: 'اضافة للدور',

    appointmentColor: 'لون الخدمة',

    addCategory: 'اضافة فئة',
    editCategory: 'تعديل فئة',

    categoryName: 'اسم الفئة',

    addingAddOn: 'اضافة اضافة-للدور',
    editAddOn: 'تعديل اضافة للدور',

    deleteAptWarning: 'هذا الإجراء سيحذف الموعد نهائيًا. هل أنت متأكد أنك تريد المتابعة؟',

    editStaffMember: 'تعديل موظف',

    staffName: 'اسم الموظف',

    settings: 'اعدادات',

    atLeastOneCharacter: 'الرجاء إضافة حرف واحد على الأقل',

    numericOnly: 'يجب أن يحتوي هذا الحقل على رقم فقط',

    saveAptB4TeamAssign: 'يجب عليك حفظ الموعد قبل تعيين أعضاء الفريق',

    deleteStaffWarning:
      'هذا الإجراء سيؤدي إلى حذف الموظف. يمكنك دائمًا التراجع عن هذا الإجراء. هل أنت متأكد أنك تريد المتابعة?',
    clickHere: 'انقر هنا',

    addOnDetials:
      'الاضافات تساعد عملائك في إضافة خدمة إضافية شائعة إلى موعدهم، مثل طلب تجفيف الشعر بعد قصه.',
    addOnDetialsP2: 'يبدو أنه ليس لديك أي إضافات.',

    addOnFirstOne: 'لإضافة أول إضافة لك.',

    settingsIntro: 'ضبط الخدمات المقدمة',

    settingsP1: 'هنا يمكنك مشاهدة وإدارة الخدمات التي تقدمها، لك ولفريقك.',
    settingsP2: 'جميع التغييرات ستظهر في التشات بوت.',

    categoryEmpty: 'هذه الفئة فارغة. ما رأيك في إضافة بعض الخدمات؟',

    date: 'تاريخ',

    january: 'يناير',
    february: 'فبراير',
    march: 'مارس',
    april: 'أبريل',
    may: 'مايو',
    june: 'يونيو',
    july: 'يوليو',
    august: 'أغسطس',
    september: 'سبتمبر',
    october: 'أكتوبر',
    november: 'نوفمبر',
    december: 'ديسمبر',

    timeTransfer: 'وقت التحويل',
    timePayment: 'وقت الدفع',

    latestCheckUp: 'آخر رسالة فحص',

    latestCheckUpResponse: 'آخر رد على رسالة فحص',

    customerAlreadyExists: 'الزبون موجود مسبقاً',

    error: 'خطأ',

    serviceTime: 'وقت الخدمة',

    mustHaveNameError: 'الرجاء إدخال اسم الزبون',

    moreDetails: 'اكثر معلومات',

    imIntrestedIn: `بدي معلومات اكثر عن`,

    cancellationReason: 'سبب الالغاء',

    other: 'اخر',
    didntAttend: 'لم يأتي',

    editAptDuration: 'تعديل مدة الدور',

    addToCart: 'اضافة الى السلة',

    shoppingCart: 'سلة المشتريات',

    orderTotal: 'المبلغ الكلي للدفع',
    subTotal: 'سعر المنتجات',

    shippingPrice: 'التوصيل',

    emptyCart: 'السلة فارغة، ابدأ التسوق',

    here: 'من هنا',

    shippingAdress: 'عنوان الشحن',

    recipientName: 'اسم المستلم',
    city: 'مدينة',
    address1: 'عنوان',
    address2: 'شقة, جناح, إلخ.',
    postalCode: '(מיקוד)الرمز البريدي',

    continuteToPayment: 'الاستمرار إلى الدفع',

    deliveryMethod: 'طريقة التوصيل',

    shipping: 'توصيل الى البيت',

    pickUp: 'استلام من',

    during: 'خلال',
    businessDays: 'ايام عمل',

    sigInWhatsapp: 'تسجيل الدخول باستخدام واتساب',

    enterPhoneToCnt: 'أدخل رقم هاتفك للمتابعة',

    idNumber: 'رقم الهوية',

    recipienAddress: 'تفاصيل مستلم الطلبية',

    region: 'منطقة',

    north: 'الشمال',
    center: 'المركز',
    south: 'الجنوب',

    hiMoreDtls: 'انا معني ب #',
    width: 'عرض',
    height: 'طول',

    delete: 'حذف',

    color: 'لون',

    participants: 'مشتركين',

    groupEvent: 'حدث مجموعة',

    addNote: 'اضافة ملاحظة',
    enterNoteHere: 'ضيف الملاحظة هون...',

    resend: 'Resend',

    didntRecieve: "Didn't get the code?",

    resendIn: 'Resend in',

    sms: 'SMS',

    whatsappAuth: 'WhatsApp',

    failedToVerifyWhatsApp: 'Failed to verify WhatsApp code. Please try again.',

    selectAuthMethod: 'Select authentication method',
  },

  heb: {
    schedule: 'קביעת תור', // Edited by

    enterPhoneForOtp: 'הכנס/י מספר טלפון נייד',

    phoneNumber: 'טלפון נייד',

    send: 'שלח/י', // Edited by

    enterPinForOtp: ' הכנס/י את קוד האימות שהתקבל בהודעה אל', // Edited by

    chooseStaff: 'בחירת עובד', // Edited by

    chooseService: 'בחירת שירות',

    morning: 'בוקר',

    afternoon: 'אחר הצהריים', // Edited by

    night: 'ערב', // Edited by

    confirm: 'קביעת תור', // Edited by

    name: 'שם מלא',

    enterFullName: 'הזנת שם מלא', // Edited by

    login: 'כניסה',

    sunday: 'יום ראשון',

    monday: 'יום שני',

    tuesday: 'יום שלישי',

    wednesday: 'יום רביעי',

    thursday: 'יום חמישי',

    friday: 'יום שישי',

    saturday: 'שבת',

    openingHours: 'שעות פעילות',

    closed: 'סגור',

    social: 'סושיאל',

    book: 'הזמנת תור', // Edited by

    signIn: 'כניסה',

    appoitment: 'תור',

    appoitments: 'תורים',

    cancel: 'ביטול',

    canceled: 'בוטל',

    at: 'בשעה',

    signOut: 'התנתק',

    reschedule: 'שינוי תור',

    invalidPhone: `מספר טלפון לא חוקי. אנא הכנס/י פורמט תקין. // Edited by
  
  לדוגמה: +9722345678901 או 05012345678`,

    generalError: 'אירעה שגיאה. אנא נסו שנית מאוחר יותר.', // Edited by

    appointmentError: 'נתקלנו בבעיה במהלך תיאום הפגישה. ייתכן שהתור כבר תפוס או עבר, אנא נסו שוב.', // Edited by

    wrongPinError: 'הוזן קוד זיהוי שגוי. אנא בדקו את קוד האימות ונסה שנית.', // Edited by

    // Start Working Hours

    workingHours: 'שעות פעילות',

    selectStaff: 'בחירת חבר/ת צוות', // Edited by

    staff: 'חבר/ת צוות', // Edited by

    timeZone: 'אזור זמן',

    weeklyWorkingHours: 'שעות עבודה שבועיות',

    start: 'התחלה',

    end: 'סיום',

    addShift: 'הוספת משמרת',

    update: 'עדכון',

    dateSpecificHours: 'ימי חופש / חריגים',

    dateSpecificText:
      'שנה/י את הזמינות שלך לתאריכים ספציפיים במקרים בהם השעות שלך חורגות ממסגרת שעות העבודה השבועית הרגילה שלך.', // Edited by

    addDateSpecificHours: 'חריגים/הוספת ימי חופש', // Edited by

    // Working Hours Spinner

    updating: 'מעדכן',

    updatingText: 'זה עשוי לקחת מספר שניות.',

    stats: 'סטטיסטיקה',

    jerusalem: 'ירושלים', // Edited by

    open: 'פתוח',

    weeklyHours: 'שעות עבודה שבועיות',

    datesOverrides: 'חריגים',

    customers: 'לקוחות',

    chats: "צ'אט",

    appointment: 'תור',

    appointments: 'תורים',

    duplicateAppointments: 'תורים כפולים',
    noDuplicateAppointments: 'לא נמצאו תורים כפולים',
    upcoming: 'עתידי',

    scheduleFor: 'קביעת תור ל',

    service: 'שירותים',
    services: 'שירותים',

    chooseCustomer: 'לקוח/ה', // Edited by

    loginText:
      'אנא הזנו את מספר הנייד המקושר לחשבון העסקי שלך. נשתמש במספר זה כדי לשלוח קוד אימות לאישור התחברות.', // Edited by

    typePhone: 'הקלד את מספר הטלפון שלך',

    twoSteps: 'אימות דו-שלבי',

    sentOtp: 'שלחנו קוד אימות לנייד שלך. הכנס את הקוד מהנייד בשדה מטה.', // Edited by

    enter6digits: 'הקלד/י את קוד האבטחה בן 6 ספרות', // Edited by

    resend: 'שלח שוב',

    didntRecieve: 'לא קיבלת את הקוד?',

    sundayFormatted: 'ראשון',

    mondayFormatted: 'שני',

    tuesdayFormatted: 'שלישי',

    wednesdayFormatted: 'רביעי',

    thursdayFormatted: 'חמישי',

    fridayFormatted: 'שישי',

    saturdayFormatted: 'שבת',

    addCustomer: 'הוספת לקוח/ה', // Edited by

    jane: 'שקד יצחק',

    confirmAction: 'אשר פעולה',

    scheduleWithoutCustomer: 'בטוחים שאתם רוצים לקבוע פגישה ללא בחירת לקוח/ה?', // Edited by

    yes: 'כן',

    no: 'לא',

    nope: 'בטל',

    addNewCustomer: 'לקוח/ה חדש', // Edited by

    reSchedule: 'שינוי תור', // Edited by

    molla: 'Molla',

    nameShort: 'שם',

    previousAppointment: 'ביקור אחרון',

    nextAppointment: 'הביקור הבא',

    searchEverything: 'חיפוש',

    today: 'היום',

    tomorrow: 'מחר',

    questionnaires: 'שאלונים',

    with: 'עם',

    call: 'התקשר',

    whatsapp: 'וואטסאפ',

    block: 'חסימה',

    lastConversation: 'שיחה אחרונה',

    joined: 'הצטרף',

    status: 'סטאטוס',

    bookings: 'הזמנות',

    payments: 'תשלומים',

    blocked: 'חסום',

    unblock: 'ביטול חסימה',

    active: 'פעיל',

    pending: 'ממתין',

    blockConfirmAction: 'בטוח/ה שאת/ה רוצה לחסום את', // Edited by

    questionMark: '?',

    charge: 'חייב',

    time: 'זמן',

    description: 'תיאור',

    price: '₪',

    cancelAppointmentDescription: 'האם את/ה בטוח/ה שברצונך לבטל את התור הזה?', // Edited by

    cancelAppointmentTitle: 'ביטול תור',

    noEventsMessage: 'אין תורים',

    tag: 'תגים',

    addTag: 'הוספת תגית',

    addNewTag: 'הוספת תגית חדשה',

    availableTags: 'תגיות זמינות',

    tagName: 'שם תגית',

    tagColor: 'צבע תגית',

    invalidPhoneNumberTitle: 'מספר לא תקין',

    invalidPhoneNumberMessage: 'אנא הכנס/י מספר טלפון תקין המורכב מספרות בלבד', // Edited by

    ok: 'אישור',

    sessionExpiredTitle: 'פג תוקף ההתחברות',

    sessionExpiredDescription: 'פג תוקף ההתחברות שלך. יש להתחבר מחדש כדי להמשיך.',

    add: 'הוספה',

    noResults: 'אין תוצאות להצגה',

    // login page general error

    loginErrorMsgTitle: 'אופס! הייתה בעיה עם הכניסה שלך',

    loginErrorMsgDescription: 'יש בעיה עם ההתחברות שלך, אנא נסו שנית',

    alreadyScheduledCustomerTitle: 'קביעת מועד חדש',

    alreadyScheduledCustomerMessageP1: 'שימו לב! הלקוח/ה כבר נקבע ליום', // Edited by

    alreadyScheduledCustomerMessageP2: 'אם תרצה/י לשנות את התור, פשוט המשך/י לקביעת מועד חדש', // Edited by

    new: 'חדש',

    notifications: 'התראות',

    notification: 'התראה',

    archive: 'ארכיון',

    theArchive: 'הארכיון',

    selectAll: 'בחר הכל',

    deSelectAll: 'הסר סימון מהכל',

    clearAllFilters: 'נקה את כל הסינונים',

    whitelistRequest: 'מעוניין להיכנס לרשימת הלקוחות שלך',

    approve: 'אישור',

    chargeErrorTitle: 'פרטי החשבונית אינם מלאים',

    chargeErrorMessage:
      'מוצר אחד או יותר מפורטים ללא מחיר. אנא ודא/י שלכל המוצרים יש מחירים לפני המשך בתהליך החיוב', // Edited by

    invoice: 'חשבונית',

    billingTo: 'חשבון ל',

    custom: 'מותאם אישית',

    products: 'מוצרים',

    soon: 'בקרוב',

    total: 'סה"כ',

    noChargeableApts: 'אין תורים שניתן לחייב עבורם',

    copy: 'העתק',

    qrMessage: 'סריקה, העתקה או שליחה דרך וואטסאפ', // Edited by

    whatsapp: 'וואטסאפ',

    refundUserDeposit: 'החזרת הפקדת המשתמש',

    selectBiz: 'בחירת עסק',

    privacyPolicy: 'מדיניות הפרטיות',

    needsAssistance: 'צריך התייחסות',

    active: 'פעיל/ה', // Edited by

    slightlyActive: 'פעיל/ה חלקית', // Edited by

    notActive: 'לא פעיל/ה', // Edited by

    helpRequest: 'רוצה את עזרתך',

    helped: 'עזרתי',

    termsOfService: 'תנאי השירות',

    notes: 'הערות',

    addNote: 'הוספת הערה',

    add: 'הוספה',

    profile: 'פרופיל',

    personalInfo: 'מידע אישי',

    save: 'שמור',

    edit: 'ערוך',

    editQuestionnaire: 'עריכת שאלון',

    invoiceSent: 'החשבונית נשלחה ללקוח/ה', // Edited by

    scheduleAnotherAptTitle: 'תזמון תור נוסף',

    scheduleAnotherAptText:
      'ברצוננו ליידע אותך שללקוח/ה זה/ו כבר יש תור. את/ה עדיין יכול לתזמן תור נוסף', // Edited by

    priceName: 'מחיר',

    priceWord: 'מחיר',

    view: 'צפייה', // Edited by

    paid: 'שולם',

    refunded: 'החזר',

    refund: 'החזר',

    pending: 'בהמתנה',

    outOf: ' מתוך ',

    refundCustomerTitle: 'החזר ללקוח/ה', // Edited by

    refundCustomerText: 'האם את/ה בטוח/ה שברצונך להחזיר', // Edited by

    to: 'ל',

    product: 'מוצר',

    customer: 'לקוח/ה', // Edited by

    download: 'יצוא',

    quantity: 'מלאי',

    image: 'תמונה',

    editProduct: 'עריכת מוצר',

    addProduct: 'הוספת מוצר',

    inStock: 'במלאי',

    missingProductDetails: 'חסרים פרטים בשפות הבאות:',
    missingInfoTitle: 'חסר מידע',

    showInBot: 'מופיע בבוט',

    bundle: 'חבילה',
    orders: 'הזמנות',

    canceledAt: 'בוטל ב',
    completedAt: 'הושלם ב',

    order: 'הזמנה',
    datePlaced: 'תאריך הזמנה',

    completed: 'הושלם',
    canceled: 'בוטל',
    pending: 'ממתין',

    complete: 'השלם',

    sortBy: 'מיין לפי',

    viewPendingOrder: 'יש הזמנה ממתינה, לחץ לצפייה',

    cancelOrder: 'האם אתה בטוח שאתה רוצה לבטל את ההזמנה הזו?',

    qty: 'כמות',

    soldOut: 'אזל מהמלאי',

    contactUsSupport: 'צור קשר ב Support@wats-va.com',

    outOf: 'מתוך',

    modifyTag: 'עריכת תגית',

    ooo: 'מחוץ למשרד',
    editooo: 'עריכת מחוץ למשרד',
    title: 'כותרת',

    deleteTagWarning: 'האם אתה בטוח שברצונך למחוק תג זה?',
    deleteAddOnWarning: 'האם אתה בטוח שברצונך למחוק תוספת זה?',
    deleteTagCategory: 'האם אתה בטוח שברצונך למחוק קטגוריות זה?',

    select: 'בחירה',

    newUsers: 'לקוחות חדשים',
    questionnairesAns: 'תשובות על שאלונים',

    overview: 'סקירה כללית',

    usersTotalNumber: 'מספר המשתמשים הכולל הוא',
    bookingsTotalNumber: 'מספר התורים הכולל הוא',
    questionnairesTotalNumber: 'מספר התשובות לשאלונים הכולל הוא',
    thisMonth: 'חודש זה',

    reviews: 'ביקורות',
    totalReviews: 'סה״כ ביקורות',
    avgRating: 'דירוג ממוצע',
    ratingDistribution: 'התפלגות דירוגים',
    rating: 'דירוג',
    reviewFeedback: 'משוב',
    unknownCustomer: 'לקוח לא ידוע',
    pageOf: 'עמוד {page} מתוך {total}',

    loginErrorBlockMsgDescription: 'היו שלושה ניסיונות כניסה כושלים או יותר. אנא נסה שנית בעוד דקה',

    slighlyActiveRequestRami: 'Didnt respond to checkup yet',

    everythingIsFine: 'הכל בסדר',
    teamMangament: 'ניהול צוות',

    team: 'צוות',

    editService: 'עריכת השירות',
    serviceName: 'שם השירות',
    category: 'קטגוריה',
    internalName: 'שם פנימי',

    downPayment: 'מקדמה',

    cost: 'מחיר',

    duration: 'משך השירות',

    addService: 'הוספת שירות',
    minutes: 'דקות',

    cancelFullRefundDaysBefore: 'החזר מלא אם בוטל לפני',

    days: 'ימים',

    general: 'הכל',

    hasFutureApt: 'תור עתידי',
    doesntHaveFutureApt: 'אין תור עתידי',

    atLeastOneStaff:
      'חייב להיות לפחות עובד אחד מוקצה לביצוע סוג זה של שירות. אם ברצונך להסתיר אותו, תוכל להסיר את השירות.',

    charLimitMsg24: 'חריגה ממגבלת התווים. וואטסאפ מאפשרת מקסימום של 24 תווים',
    charLimitMsg60: 'חריגה ממגבלת התווים. וואטסאפ מאפשרת מקסימום של 60 תווים',

    missingOrRequired: 'אנא מלא את כל השדות הנדרשים, אשר מודגשים באדום',

    addOns: 'תוספת לתור',

    addAppointment: 'שירות',

    addAddOn: 'תוספת',

    appointmentColor: 'צבע התור',

    addCategory: 'הוספת קטגוריה',
    editCategory: 'עריכת קטגוריה',

    categoryName: 'שם הקטגוריה',

    editAddOn: 'עריכת תוספת לתור',
    addingAddOn: 'הוספת תוספת לתור',

    deleteAptWarning: 'פעולה זו תמחק את התור. האם אתה בטוח שברצונך להמשיך?',

    editStaffMember: 'עריכת איש צוות',

    staffName: 'שם איש צוות',

    settings: 'הגדרות',
    atLeastOneCharacter: 'אנא הוסף לפחות תו אחד',

    numericOnly: 'שדה זה יכול להכיל מספר בלבד',

    saveAptB4TeamAssign: 'עליך לשמור את הפגישה לפני הקצאת חברי הצוות',

    deleteStaffWarning:
      'פעולה זו תמחק את העובד. תמיד תוכל לבטל את הפעולה הזו. האם אתה בטוח שברצונך להמשיך?',
    clickHere: 'לחץ כאן',

    addOnDetials:
      'תוספות עוזרות ללקוחות שלך להוסיף שירות נוסף נפוץ לפגישתם, כמו לבקש ייבוש שיער לאחר גזורת השיער.',
    addOnDetialsP2: 'נראה שאין לך תוספות.',
    addOnFirstOne: 'כדי להוסיף את התוספת הראשונה של.',

    settingsIntro: 'הגדר את השירותים המוצעים',
    settingsP1: 'כאן תוכל לצפות ולנהל את השירותים שאתה מציע לך ולצוות שלך.',

    settingsP2: 'כל השינויים יופיעו בבוט.',

    categoryEmpty: 'הקטגוריה הזו ריקה. מה דעתך להוסיף כמה שירותים?',

    date: 'תאריך',

    january: 'ינואר',
    february: 'פברואר',
    march: 'מרץ',
    april: 'אפריל',
    may: 'מאי',
    june: 'יוני',
    july: 'יולי',
    august: 'אוגוסט',
    september: 'ספטמבר',
    october: 'אוקטובר',
    november: 'נובמבר',
    december: 'דצמבר',

    timeTransfer: 'זמן העברה',
    timePayment: 'זמן תשלום',

    latestCheckUp: 'הודעת בדיקה אחרונה',

    latestCheckUpResponse: 'מענה אחרון על הודעת בדיקה',

    customerAlreadyExists: 'הלקוח כבר קיים',

    error: 'שגיאה',

    serviceTime: 'זמן תור',

    mustHaveNameError: 'אנא הזן שם לקוח',

    moreDetails: 'עוד מידע',

    imIntrestedIn: `ספר לי עוד על`,
    cancellationReason: 'סיבת ביטול',

    other: 'אחר',
    didntAttend: 'לא הגיע',

    editAptDuration: 'עריכת זמן התור',

    addToCart: 'הוספה לסל',
    shoppingCart: 'עגלת קניות',

    orderTotal: 'סך הכל לתשלום',
    subTotal: 'סכום חלקי',

    shippingPrice: 'משלוח',

    emptyCart: 'העגלה ריקה, התחל לקנות',

    here: ' פה',

    shippingAdress: 'כתובת למשלוח',

    recipientName: 'שם המקבל',
    city: 'עיר',
    address1: 'כתובת',
    address2: 'דירה, סוויטה ',
    postalCode: 'מיקוד',

    continuteToPayment: 'המשך לתשלום',

    deliveryMethod: 'שיטת משלוח',

    shipping: 'משלוח עד הבית',

    pickUp: 'איסוף',

    during: 'תוך',
    businessDays: 'ימי עסקים',

    sigInWhatsapp: 'התחבר באמצעות וואטסאפ',

    enterPhoneToCnt: 'הזן את מספר הטלפון שלך כדי להמשיך',

    idNumber: 'תעודת זהות',

    recipienAddress: 'פרטי מקבל הזמנה',

    region: 'אזור',

    north: 'צפון',
    center: 'מרכז',
    south: 'דרום',

    hiMoreDtls: 'אני מעוניין ב #',

    width: 'רוחב',
    height: 'גובה',

    delete: 'מחיקה',
    color: 'צבע',

    participants: 'משתתפים',

    groupEvent: 'אירוע קבוצתי',

    addNote: 'הוספת הערה',
    enterNoteHere: 'הוסף הערה פה...',

    resend: 'Resend',

    didntRecieve: "Didn't get the code?",

    resendIn: 'Resend in',

    sms: 'SMS',

    whatsappAuth: 'WhatsApp',

    failedToVerifyWhatsApp: 'Failed to verify WhatsApp code. Please try again.',

    selectAuthMethod: 'Select authentication method',
  },
  ru: {
    schedule: 'Записаться',
    enterPhoneForOtp: 'Введите номер телефона',
    phoneNumber: 'Телефон',
    send: 'Отправить',
    enterPinForOtp: 'Введите код подтверждения, который вы получили в сообщении на ',
    chooseStaff: 'Выберите специалиста',
    chooseService: 'Выберите услугу',
    morning: 'Утро',
    afternoon: 'День',
    night: 'Вечер',
    confirm: 'Записаться на прием',
    name: 'Полное имя',
    enterFullName: 'Введите полное имя',
    login: 'Войти',
    sunday: 'Воскресенье',
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    openingHours: 'Часы работы',
    closed: 'Закрыто',
    social: 'Социальные сети',
    book: 'Записаться',
    signIn: 'Войти',
    signOut: 'Выйти',
    appoitment: 'Запись',
    appoitments: 'Записи',
    cancel: 'Отменить',
    canceled: 'Отменено',
    at: 'в',
    reschedule: 'Перенести',
    invalidPhone:
      'Неверный номер телефона. Пожалуйста, введите в правильном формате. Например: +9722345678901 или 05012345678',
    generalError: 'Произошла ошибка. Пожалуйста, попробуйте позже.',
    appointmentError:
      'Возникла проблема при записи. Это время может быть занято или уже прошло, пожалуйста, попробуйте снова.',
    wrongPinError:
      'Введен неверный PIN-код. Пожалуйста, убедитесь, что вы используете правильный код, отправленный на ваш номер телефона, и попробуйте снова.',
    workingHours: 'Рабочие часы',
    selectStaff: 'Выберите специалиста',
    timeZone: 'Часовой пояс',
    weeklyWorkingHours: 'Еженедельные рабочие часы',
    start: 'Начало',
    end: 'Конец',
    addShift: 'Добавить смену',
    update: 'Обновить',
    dateSpecificHours: 'Часы для конкретных дат',
    dateSpecificText:
      'Измените доступность для конкретных дат, когда ваши часы отличаются от обычного еженедельного расписания.',
    addDateSpecificHours: 'Добавить часы для конкретных дат',
    updating: 'Обновление',
    updatingText: 'Это может занять несколько секунд',
    stats: 'Статистика',
    jerusalem: 'Иерусалим',
    open: 'Открыто',
    weeklyHours: 'Еженедельные часы',
    datesOverrides: 'Конкретные даты',
    customers: 'Клиенты',
    chats: 'Чаты',
    appointment: 'Запись',
    appointments: 'Записи',
    chooseCustomer: 'Выберите клиента',
    scheduleFor: 'Записать для',
    staff: 'Специалист',
    service: 'Услуга',
    services: 'Услуги',
    loginText:
      'Пожалуйста, введите мобильный номер, связанный с вашей учетной записью. Мы используем этот номер для отправки кода подтверждения для входа.',
    typePhone: 'Введите ваш номер телефона',
    twoSteps: 'Двухэтапная проверка',
    sentOtp: 'Мы отправили код подтверждения на ваш мобильный. Введите код в поле ниже.',
    enter6digits: 'Введите ваш 6-значный код безопасности',
    resend: 'Отправить повторно',
    didntRecieve: 'Не получили код?',
    sundayFormatted: 'Вс',
    mondayFormatted: 'Пн',
    tuesdayFormatted: 'Вт',
    wednesdayFormatted: 'Ср',
    thursdayFormatted: 'Чт',
    fridayFormatted: 'Пт',
    saturdayFormatted: 'Сб',

    // Recurring Appointments
    recurringAppointment: 'Повторяющаяся запись',
    recurringAppointments: 'Повторяющиеся записи',
    duplicateAppointments: 'Дублирующиеся записи',
    noDuplicateAppointments: 'Дублирующиеся записи не найдены',
    upcoming: 'Предстоящая',
    recurringSettings: 'Настройки повторения',
    scheduleRecurring: 'Создать повторяющуюся',
    updateRecurring: 'Обновить',
    editRecurringRule: 'Изменить правило повторения',
    cancelSeries: 'Отменить серию',
    cancelRecurringSeries: 'Отменить повторяющуюся серию',
    confirmCancelRecurringSeries: 'Вы уверены, что хотите отменить всю повторяющуюся серию? Все будущие записи будут отменены.',
    totalAppointments: 'Всего записей',
    recurringEvent: 'Повторяющаяся',
    frequency: 'Частота',
    dayOfWeek: 'День недели',
    every: 'Каждые',
    week: 'Неделя',
    weeks: 'Недели',
    weekly: 'Еженедельно',
    biweekly: 'Раз в две недели',
    monthly: 'Ежемесячно',
    startDate: 'Дата начала',
    details: 'Детали',

    addCustomer: 'Добавить клиента',
    jane: 'Анна Иванова',
    confirmAction: 'Подтвердить действие',
    scheduleWithoutCustomer: 'Вы не можете создать запись без выбора клиента',
    yes: 'Да',
    no: 'Нет',
    nope: 'Отмена',
    addNewCustomer: 'Добавить нового клиента',
    reSchedule: 'Перенести запись',
    molla: 'Молла',
    nameShort: 'Имя',
    previousAppointment: 'Предыдущая запись',
    nextAppointment: 'Следующая запись',
    searchEverything: 'Поиск',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    questionnaires: 'Анкеты',
    with: 'с',
    call: 'Позвонить',
    whatsapp: 'WhatsApp',
    block: 'Заблокировать',
    unblock: 'Разблокировать',
    lastConversation: 'Последний разговор',
    joined: 'Присоединился',
    status: 'Статус',
    bookings: 'Бронирования',
    payments: 'Платежи',
    blocked: 'Заблокирован',
    active: 'Активный',
    pending: 'В ожидании',
    blockConfirmAction: 'Вы уверены, что хотите заблокировать',
    questionMark: '?',
    charge: 'Оплатить',
    time: 'Время',
    description: 'Описание',
    price: '₪',
    cancelAppointmentDescription: 'Вы уверены, что хотите отменить эту запись?',
    cancelAppointmentTitle: 'Отменить запись',
    noEventsMessage: 'Событий пока нет',
    tag: 'Теги',
    addTag: 'Добавить тег',
    addNewTag: 'Добавить новый тег',
    availableTags: 'Доступные теги',
    modifyTag: 'Изменить тег',
    tagName: 'Название тега',
    tagColor: 'Цвет тега',
    invalidPhoneNumberTitle: 'Неверный номер телефона',
    invalidPhoneNumberMessage:
      'Пожалуйста, введите действительный номер телефона, состоящий только из цифр',
    ok: 'Хорошо',
    sessionExpiredTitle: 'Сеанс истек',
    sessionExpiredDescription: 'Срок действия вашей сессии истек. Пожалуйста, войдите снова, чтобы продолжить.',
    add: 'Добавить',
    noResults: 'Нет доступных записей',
    loginErrorMsgTitle: 'Упс! Возникла проблема с входом',
    loginErrorMsgDescription: 'Произошла ошибка при входе, пожалуйста, попробуйте снова',
    alreadyScheduledCustomerTitle: 'Перенести запись',
    alreadyScheduledCustomerMessageP1: 'Внимание! Клиент уже записан на',
    alreadyScheduledCustomerMessageP2: 'Если вам нужно изменить запись, просто перенесите ее',
    new: 'Новый',
    notifications: 'Уведомления',
    notification: 'Уведомление',
    archive: 'Архив',
    theArchive: 'Входящие',
    selectAll: 'Выбрать все',
    deSelectAll: 'Снять выделение',
    clearAllFilters: 'Сбросить все фильтры',
    whitelistRequest: 'Хочет стать вашим клиентом',
    approve: 'Одобрить',
    chargeErrorTitle: 'Неполные данные счета',
    chargeErrorMessage:
      'У одного или нескольких товаров не указана цена. Пожалуйста, убедитесь, что у всех товаров есть цены, прежде чем продолжить.',
    invoice: 'Счет',
    billingTo: 'СЧЕТ ДЛЯ:',
    custom: 'Пользовательский',
    products: 'Товары',
    soon: 'Скоро',
    total: 'ИТОГО:',
    noChargableApts: 'Нет оплачиваемых записей',
    copy: 'Копировать',
    qrMessage: 'Сканировать, копировать или отправить через WhatsApp',
    refundUserDeposit: 'Вернуть депозит пользователю',
    selectBiz: 'Выберите бизнес',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    needsAssistance: 'Нуждается в помощи',
    slightlyActive: 'Слегка активный',
    notActive: 'Не активный',
    helpRequest: 'Нуждается в вашей помощи',
    slighlyActiveRequestRami: 'Еще не ответил на проверку',
    everythingIsFine: 'Все в порядке',
    helped: 'Помогли',
    notes: 'Заметки',
    addNote: 'Добавить заметку',
    profile: 'Профиль',
    personalInfo: 'Личная информация',
    save: 'Сохранить',
    edit: 'Редактировать',
    editQuestionnaire: 'Редактировать анкету',
    invoiceSent: 'Счет был отправлен клиенту',
    priceWord: 'Цена',
    view: 'Просмотр',
    refunded: 'Возвращено',
    refund: 'Возврат',
    paid: 'Оплачено',
    outOf: ' из ',
    refundCustomerTitle: 'Вернуть деньги клиенту',
    refundCustomerText: 'Вы уверены, что хотите вернуть',
    to: 'к',
    scheduleAnotherAptTitle: 'Планирование еще одной записи',
    scheduleAnotherAptText: 'У этого клиента уже есть запись. Хотите все равно записать еще одну?',
    product: 'Товар',
    download: 'Экспорт',
    priceName: 'Цена',
    quantity: 'Количество',
    image: 'Изображение',
    editProduct: 'Редактировать товар',
    addProduct: 'Добавить товар',
    inStock: 'в наличии',
    customer: 'Клиент',
    missingInfoTitle: 'Отсутствует или неверная информация',
    missingProductDetails: 'Отсутствует информация на этих языках:',
    showInBot: 'Показывать в боте',
    bundle: 'Набор',
    orders: 'Заказы',
    canceledAt: 'Отменено в',
    completedAt: 'Завершено в',
    order: 'Заказ',
    datePlaced: 'Дата размещения',
    completed: 'Завершено',
    canceled: 'Отменено',
    complete: 'Завершить',
    sortBy: 'Сортировать по',
    viewPendingOrder: 'Есть ожидающий заказ, нажмите для просмотра',
    cancelOrder: 'Вы уверены, что хотите отменить этот заказ?',
    qty: 'Кол-во',
    soldOut: 'Распродано',
    contactUsSupport: 'Свяжитесь с нами по адресу Support@wats-va.com',
    deleteTagWarning: 'Вы уверены, что хотите удалить этот тег?',
    deleteAddOnWarning: 'Вы уверены, что хотите удалить это дополнение?',
    deleteTagCategory: 'Вы уверены, что хотите удалить эту категорию?',
    select: 'Выбрать',
    newUsers: 'Новые пользователи',
    questionnairesAns: 'Ответы на анкеты',
    overview: 'Обзор',
    bookingsTotalNumber: 'Общее количество бронирований',
    usersTotalNumber: 'Общее количество пользователей',
    questionnairesTotalNumber: 'Общее количество ответов на анкеты',
    thisMonth: 'В этом месяце',

    reviews: 'Отзывы',
    totalReviews: 'Всего отзывов',
    avgRating: 'Средняя оценка',
    ratingDistribution: 'Распределение оценок',
    rating: 'Оценка',
    reviewFeedback: 'Отзыв',
    unknownCustomer: 'Неизвестный клиент',
    pageOf: 'Страница {page} из {total}',
    ooo: 'Вне офиса',
    editooo: 'Редактировать статус вне офиса',
    title: 'Название',
    loginErrorBlockMsgDescription:
      'Было 3 или более неудачных попыток входа. Пожалуйста, попробуйте снова через 1 минуту',
    teamMangament: 'Управление командой',
    team: 'Команда',
    editService: 'Редактировать услугу',
    addService: 'Добавить услугу',
    serviceName: 'Название услуги',
    category: 'Категория',
    internalName: 'Внутреннее название',
    downPayment: 'Предоплата',
    cost: 'Цена',
    duration: 'Продолжительность',
    minutes: 'мин',
    cancelFullRefundDaysBefore: 'Полный возврат при отмене за',
    days: 'Дней',
    general: 'Общее',
    hasFutureApt: 'Будущая запись',
    doesntHaveFutureApt: 'Нет будущей записи',
    atLeastOneStaff:
      'Должен быть назначен хотя бы один специалист для выполнения этого типа услуги. Если вы хотите скрыть ее, вы можете удалить запись.',
    atLeastOneCharacter: 'Требуется ввод. Пожалуйста, добавьте хотя бы один символ',
    numericOnly: 'Это поле может содержать только число',
    charLimitMsg24: 'Превышен лимит символов. WhatsApp позволяет максимум 24 символа',
    charLimitMsg60: 'Превышен лимит символов. WhatsApp позволяет максимум 60 символов',
    missingOrRequired: 'Пожалуйста, заполните все обязательные поля, выделенные красным',
    addOns: 'Дополнения к записи',
    addAppointment: 'Услуга',
    addAddOn: 'Дополнение',
    appointmentColor: 'Цвет записи',
    addCategory: 'Добавить категорию',
    editCategory: 'Редактировать категорию',
    categoryName: 'Название категории',
    addingAddOn: 'Добавить дополнение',
    editAddOn: 'Редактировать дополнение',
    deleteAptWarning: 'Это действие навсегда удалит запись. Вы уверены, что хотите продолжить?',
    editStaffMember: 'Редактировать специалиста',
    staffName: 'Имя специалиста',
    settings: 'Настройки',
    saveAptB4TeamAssign: 'Вы должны сохранить запись перед назначением членов команды',
    deleteStaffWarning:
      'Это действие удалит специалиста. Вы всегда можете отменить это действие. Вы уверены, что хотите продолжить?',
    clickHere: 'Нажмите здесь',
    addOnDetials:
      'Дополнения помогают вашим клиентам добавить общую дополнительную услугу к своей записи, например, попросить укладку вместе со стрижкой.',
    addOnDetialsP2: 'Похоже, у вас нет дополнений.',
    addOnFirstOne: 'чтобы добавить ваше первое дополнение.',
    settingsIntro: 'Настроить предлагаемые услуги',
    settingsP1:
      'Здесь вы можете просматривать и управлять предлагаемыми услугами для вас и вашей команды.',
    settingsP2: 'Все изменения появятся в чат-боте.',
    categoryEmpty: 'Эта категория пуста. Как насчет добавления некоторых услуг?',
    date: 'Дата',
    january: 'Январь',
    february: 'Февраль',
    march: 'Март',
    april: 'Апрель',
    may: 'Май',
    june: 'Июнь',
    july: 'Июль',
    august: 'Август',
    september: 'Сентябрь',
    october: 'Октябрь',
    november: 'Ноябрь',
    december: 'Декабрь',
    timeTransfer: 'Время перевода',
    timePayment: 'Время оплаты',
    latestCheckUp: 'Последняя проверка отправлена',
    latestCheckUpResponse: 'Ответ на последнее сообщение проверки',
    customerAlreadyExists: 'Клиент уже существует',
    error: 'Ошибка',
    serviceTime: 'Время услуги',
    mustHaveNameError: 'Пожалуйста, введите имя клиента',
    moreDetails: 'Подробнее',
    imIntrestedIn: 'Меня интересует',
    cancellationReason: 'Причина отмены',
    other: 'Другое',
    didntAttend: 'Не пришел',
    editAptDuration: 'Изменить продолжительность записи',
    addToCart: 'Добавить в корзину',
    shoppingCart: 'Корзина',
    orderTotal: 'Итого заказа',
    subTotal: 'Промежуточный итог',
    shippingPrice: 'Доставка',
    emptyCart: 'Корзина пуста, начните покупки',
    here: 'Здесь',
    shippingAdress: 'Адрес доставки',
    recipientName: 'Имя получателя',
    city: 'Город',
    address1: 'Адрес',
    address2: 'Квартира, офис и т.д.',
    postalCode: 'Почтовый индекс',
    continuteToPayment: 'Продолжить к оплате',
    deliveryMethod: 'Способ доставки',
    shipping: 'Доставка',
    pickUp: 'Самовывоз',
    during: '',
    businessDays: 'рабочих дней',
    sigInWhatsapp: 'Войти через WhatsApp',
    enterPhoneToCnt: 'Введите ваш номер телефона для продолжения',
    idNumber: 'Номер удостоверения личности',
    recipienAddress: 'Данные получателя',
    region: 'Регион',
    north: 'Север',
    center: 'Центр',
    south: 'Юг',
    hiMoreDtls: 'Привет, мне нужны подробности о #',
    width: 'Ширина',
    height: 'Высота',
    delete: 'Удалить',
    color: 'Цвет',
    participants: 'Участники',
    groupEvent: 'Групповое мероприятие',
    enterNoteHere: 'Введите вашу заметку здесь...',
    resendIn: 'Отправить повторно через',
    sms: 'СМС',
    whatsappAuth: 'WhatsApp',
    failedToVerifyWhatsApp: 'Не удалось проверить код WhatsApp. Пожалуйста, попробуйте снова.',
    selectAuthMethod: 'Выберите метод аутентификации',
  },
};

export default translations;
